import { DsmContractSelection } from '../models/dsm-contract-details.models';
import {
  DsmAddendumProductAttributePayload,
  DsmAddendumProductPayload,
  DsmSelectedProductEntry
} from '../models/dsm-deal-options.models';
import { DsmSelectionBasketOptionPayload } from '../models/dsm-selection-basket.models';

function toDsmAddendumProductAttributes(attributeValues: Record<string, string>): DsmAddendumProductAttributePayload[] {
  return Object.entries(attributeValues).map(([attributeId, valueId]) => ({
    subCategoryAttributeId: attributeId,
    subCategoryAttributeValueId: valueId
  }));
}

export function toDsmAddendumProductPayload(entry: DsmSelectedProductEntry): DsmAddendumProductPayload {
  const payload: DsmAddendumProductPayload = {
    modelElevationProductsId: entry.product.modelElevationProductsId,
    selectedLocationId: entry.values.locationId,
    unitPrice: entry.values.unitPrice,
    quantity: entry.values.quantity,
    notes: entry.values.notes,
    attributes: toDsmAddendumProductAttributes(entry.values.attributeValues)
  };

  if (entry.packageId) {
    payload.packageId = entry.packageId;
  }

  const linkedProducts = (entry.values.linkedProducts ?? []).map(linked => ({
    modelElevationProductsId: linked.modelElevationProductsId,
    selectedLocationId: linked.locationId,
    notes: linked.notes,
    quantity: linked.quantity,
    unitPrice: linked.unitPrice,
    attributes: toDsmAddendumProductAttributes(linked.attributeValues)
  }));

  if (linkedProducts.length) {
    payload.linkedProducts = linkedProducts;
  }

  return payload;
}

export function toDsmSelectionBasketOptionPayload(selection: DsmContractSelection): DsmSelectionBasketOptionPayload {
  const hasDiscount = selection.discountValue > 0;

  return {
    ...toDsmAddendumProductPayload(selection),
    optionKey: selection.id,
    discountTypeId: hasDiscount ? selection.discountType : null,
    discountValue: hasDiscount ? selection.discountValue : null
  };
}
